module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "oper-wrap"
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (num),
      expression: "num"
    }],
    staticClass: "minus",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        minusDish($event)
      }
    }
  }, [_m(0)]), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (num),
      expression: "num"
    }],
    staticClass: "num"
  }, [_h('span', [_s(num ? num : '')])]), " ", _h('div', {
    staticClass: "add",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        addDish($event)
      }
    }
  }, [_m(1)])])
}},staticRenderFns: [function (){with(this) {
  return _h('i', {
    staticClass: "bg"
  })
}},function (){with(this) {
  return _h('i', {
    staticClass: "bg"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-343e87c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemOper.vue
 ** module id = 71
 ** module chunks = 1
 **/